import { useEffect, useState } from "react"
import {
  CONTAINER_ICON_WIDTH,
  getResponsiveConfig,
  type DockResponsiveConfig,
} from "./dock-config"

export function useDockResponsive() {
  const [config, setConfig] = useState<DockResponsiveConfig>(getResponsiveConfig)
  const baseSpacing = Math.max(4, CONTAINER_ICON_WIDTH * 0.08)

  useEffect(() => {
    const handleResize = () => setConfig(getResponsiveConfig())
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return { config, baseSpacing }
}
